import type { Order } from "./types";

/** Ultimo evento corriere cacheato dal backend (``orders.last_tracking_event``). */
export type ApiTrackingEvent = {
  label?: string;
  status?: string;
  location?: string;
  at?: string;
  delivered?: boolean;
  ritorno_mittente?: boolean;
  /** false = «Non ancora affidata»: il corriere non ha il pacco. Assente = true,
   *  come ``ritiri.partito`` nel backend. */
  partito?: boolean;
};

export function mapTrackingEvent(
  ev: ApiTrackingEvent | null | undefined,
): Order["lastTrackingEvent"] {
  if (!ev) return null;
  return {
    label: ev.label ?? "",
    delivered: ev.delivered === true,
    ritornoMittente: ev.ritorno_mittente === true,
    partito: ev.partito !== false,
    location: ev.location ?? "",
    at: ev.at ?? "",
  };
}
